import config from './config.json'
import http from './httpService'

export const getNetworksCoin = coinId =>{
    return http.get(`${config.coinbaseapi}/coins/${coinId}/networks`)
}